import { map, take } from 'rxjs';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ClassService } from '@app/cadastro/admin';
import { LexTranslateService } from '@app/core/services/lex-translate.service';
import { tap } from 'rxjs';

interface DialogData {
  classId: string
}

@Component({
  selector: 'seb-access-card-profile-dialog',
  templateUrl: './access-card-profile-dialog.component.html',
  styleUrls: ['./access-card-profile-dialog.component.css']
})
export class AccessCardProfileDialogComponent implements OnInit {
  options = []
  selected = [];

  constructor(
    public lextranslate: LexTranslateService,
    public classService: ClassService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { }

  ngOnInit(): void {
    this.loadProfiles();
  }

  loadProfiles() {
    this.classService.getProfilesbyClassId(this.data.classId).pipe(take(1)).subscribe({
      next: (res) => {
        this.options = res.profiles.map((item) => {
          return {
            id: item.id,
            nome: item.name,
            backgroundColor: 'rgba(0, 0, 0, 0.38)',
            textColor: '#fff'
          }
        })
      }
    });
  }

}
